import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Card, CardContent, Button, Chip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import VendorImage from './VendorImage';
import { buildVendorJoinHref } from '../../../shared/vendorDirectory/vendorDirectoryPaths';
import { isViteFlagEnabled } from '../../utils/runtimePlatformFlags';
import type { FeaturedVendorDto } from '../../types/vendorDirectoryPublic';

const FeaturedVendorsSection: React.FC = () => {
  const enabled = isViteFlagEnabled('VITE_VENDOR_DIRECTORY_ENABLED', import.meta.env.VITE_VENDOR_DIRECTORY_ENABLED);
  const [vendors, setVendors] = useState<FeaturedVendorDto[]>([]);

  useEffect(() => {
    if (!enabled) return;
    fetch('/api/vendor-directory/vendors/featured')
      .then((r) => r.json())
      .then((d) => { if (d.success) setVendors(d.data.vendors ?? []); })
      .catch(() => undefined);
  }, [enabled]);

  if (!enabled || vendors.length === 0) return null;

  return (
    <Box sx={{ py: { xs: 6, md: 8 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h4" component="h2">Featured vendors</Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button component={RouterLink} to="/vendors" variant="outlined">Browse directory</Button>
          <Button component={RouterLink} to={buildVendorJoinHref()} variant="contained">List your company</Button>
        </Box>
      </Box>
      <Grid container spacing={3}>
        {vendors.map((v) => (
          <Grid item xs={12} sm={6} md={4} key={v.slug}>
            <Card component={RouterLink} to={`/vendors/${v.slug}`} sx={{ textDecoration: 'none', height: '100%' }}>
              <VendorImage src={v.logoUrl} alt={v.name} height={120} />
              <CardContent>
                <Typography variant="h6">{v.name}</Typography>
                {v.tagline && <Typography variant="body2" color="text.secondary">{v.tagline}</Typography>}
                {v.verified && <Chip size="small" label="Verified vendor" color="success" sx={{ mt: 1 }} />}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturedVendorsSection;
